<custom-modal-card
  *ngIf="{
    tags: tags$ | async,
    tvShows: tvShows$ | async,
    badges: badges$ | async,
    violations: violations$ | async
  } as STATE"
  class="edit-video mat-dialog-transparent"
>
  <ng-container header>
    <default-modal-header
      [title]="modalTitle"
      [description]="modalDescription"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form [formGroup]="form" class="resource-form">
      <article>
        <mat-label>Intitulé de la vidéo *</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <input
            formControlName="name"
            matInput
            placeholder="Entrez le titre de la vidéo"
          />
        </mat-form-field>
        <mat-error *ngIf="form.get('name')?.getError('httpError') as httpError">
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Description de la vidéo *</mat-label>
        <mat-form-field>
          <textarea
            formControlName="description"
            matInput
            rows="5"
            placeholder="Entrez la description à afficher"
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('description')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Programme *</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="programId">
            <mat-option *ngFor="let show of STATE.tvShows" [value]="show.id">
              {{ show.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
      </article>
      <article>
        <mat-label>Tags de la vidéo *</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/hashtag.svg" alt="" />
          </div>
          <mat-select formControlName="tagIds" [multiple]="true">
            <mat-option *ngFor="let tag of STATE.tags" [value]="tag.id">
              {{ tag.title }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
      </article>
      <article>
        <mat-label>Badges de la vidéo</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/hashtag.svg" alt="" />
          </div>
          <mat-select formControlName="badgeIds" [multiple]="true">
            <mat-option *ngFor="let item of STATE.badges" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
      </article>

      <article>
        <mat-label>Vignette de la vidéo</mat-label>
        <video-thumbnail-selector
          (selection)="selectThumbnail($event)"
          [kalturaMediaId]="video?.mediaSource?.id || media?.id"
          [preselectedMediaId]="video?.thumbnailUrl || media?.thumbnailUrl"
        ></video-thumbnail-selector>
      </article>
    </form>
  </ng-container>

  <footer footer class="resource-form">
    <ng-container *ngIf="isMedia">
      <button
        (click)="importMedia(false)"
        [attr.loading]="isLoadingImport"
        [disabled]="
          !isFormValid || isLoadingImport || isLoadingImportWithPublication
        "
        class="btn btn--primary-light btn--full"
      >
        Importer seulement
      </button>
      <button
        (click)="importMedia()"
        [attr.loading]="isLoadingImportWithPublication"
        [disabled]="
          !isFormValid || isLoadingImport || isLoadingImportWithPublication
        "
        class="btn btn--tertiary btn--full"
      >
        {{
          media?.status === kalturaVideoStatus.READY
            ? 'Importer et publier après traitement'
            : 'Importer et publier la vidéo'
        }}
      </button>
    </ng-container>

    <ng-container *ngIf="!isMedia">
      <button
        (click)="updateVideo()"
        [attr.loading]="isLoading"
        [disabled]="form.invalid || isLoading"
        class="btn btn--primary-light btn--full"
      >
        Mettre à jour les informations
      </button>

      <ng-container *ngIf="canPublishVideo">
        <button
          (click)="updateVideo(true)"
          [attr.loading]="isLoadingWithPublication"
          [disabled]="form.invalid || isLoading"
          class="btn btn--primary-light btn--full"
        >
          {{
            media?.status !== kalturaVideoStatus.READY
              ? 'Mettre à jour et publier après traitement'
              : 'Mettre à jour et publier'
          }}
        </button>
      </ng-container>
    </ng-container>
  </footer>
</custom-modal-card>
